import { Amount } from '@root/api/ump-ewallet'

export const getClientTotalAmount = (amount: Amount | null, isPromocodeActivated: boolean, isSteam: boolean) => {
  if (!amount || !amount.base) return '0'

  if (isPromocodeActivated && isSteam) {
    return amount.base
  }

  return amount.total || '0'
}
